<template>
    <div class="my-diy-list">
        <div></div>
        <div>
            <ul>
                <li></li>
            </ul>
        </div>
        <div class="add"><button @click="goto">+ 现在去定制</button></div>
    </div>
</template>
<script>
export default {
    data(){
        return{

        }
    },
    methods:{
        goto(){
            this.$router.push({
                path: '/makingcard'
            })
        }
    }
}
</script>
<style lang="scss" scoped>
    .my-diy-list{
        font-size: 0.32rem;
        .add{
            position: fixed;
            bottom: 1rem;
            width: 100%;
            button{
                margin: auto;
                display: block;
                width: 7.18rem;
                height: 0.86rem;
                background-color: #FF6161;
                color: white;
                border: none;
                border-radius: 20px;
            }
            
        }
    }
</style>